import { useGlobalQuery } from '@/state/query-client/hooks';
import {
  getMbmProjectsLookup,
  getTimeSheetEntries,
  getUsersTimesheetRollup,
} from '../services/timesheet-manager.service';
import { GetTimeSheetsParams, UsersTimesheetFilter } from '../types/timesheet-manager.types';

export const useGetTimeSheetEntries = (params: GetTimeSheetsParams) => {
  return useGlobalQuery({
    queryKey: ['hr-timesheet-manager-entries', params],
    queryFn: () => getTimeSheetEntries(params),
    staleTime: 60 * 1000,
  });
};

export const useGetUsersTimesheetRollup = (filter: UsersTimesheetFilter) => {
  return useGlobalQuery({
    queryKey: ['hr-timesheet-manager-rollup', filter],
    queryFn: () => getUsersTimesheetRollup(filter),
    staleTime: 60 * 1000,
  });
};

export const useGetMbmProjectsLookup = () => {
  return useGlobalQuery({
    queryKey: ['hr-timesheet-manager-mbm-projects'],
    queryFn: () => getMbmProjectsLookup(),
    staleTime: 30 * 60 * 1000,
  });
};
